// extracted by mini-css-extract-plugin
export default {"container":"Pension_container__jTNVt","table":"Pension_table__SL6qM","kfarHashashuim":"Pension_kfarHashashuim__dcVYV"};